import HTMLReactParser, { HTMLReactParserOptions } from 'html-react-parser';
import React from 'react';
import xss, { IFilterXSSOptions } from 'xss';

type Props = {
  html: string,
  parserOptions?: HTMLReactParserOptions,
  xssOptions?: IFilterXSSOptions;
}

const HTMLReactParserSafe: React.FC<Props> = ({ html, parserOptions, xssOptions }) => {
  return (
    <>{HTMLReactParser(xss(html, xssOptions), parserOptions)}</>
  );
};

export default HTMLReactParserSafe;
